export enum UserFeedbackCategory {
  Affordability = 1,
  ClaimsForm = 2,
  Criteria = 3,
  EOR = 4,
  ESIS = 5,
  GeneralSite = 6,
  MI = 7,
  MyAccount = 8,
  Product = 9,
  Property = 10,
}

export enum UserFeedbackType
{
  Improvement = 1,
  Bug = 2,
}

export enum AppType
{
  LenderHub = 1,
  ClubHub = 2,
  All = 3,
}
